/**
 * GraphQL type definitions matching backend schema — project pillar.
 * Split from graphql/types.ts (issue #1409).
 */

import type { PageInfo } from './common';

export enum ProjectStatus {
  Planning = 'planning',
  Active = 'active',
  OnHold = 'on_hold',
  Complete = 'complete',
  Archived = 'archived',
}

export enum ProjectMilestoneStatus {
  NotStarted = 'not_started',
  InProgress = 'in_progress',
  Complete = 'complete',
  Slipped = 'slipped',
}

export enum ProjectOutcomeStatus {
  Active = 'active',
  Archived = 'archived',
}

export enum AssignmentStatus {
  Planned = 'planned',
  InProgress = 'in_progress',
  Done = 'done',
}

export interface Project {
  entityId: string;
  entityType: string;
  name: string;
  description?: string | null;
  status: ProjectStatus;
  ownerDivision: string;
  ownerTeamId?: string | null;
  startDate?: string | null;
  targetEndDate?: string | null;
  _schemaVersion: string;
  _createdAt: string;
  _createdBy: string;
  _updatedAt: string;
  _updatedBy: string;
  _deletedAt?: string | null;
}

export interface ProjectEdge {
  node: Project;
  cursor: string;
}

export interface ProjectConnection {
  edges: ProjectEdge[];
  pageInfo: PageInfo;
  totalCount?: number | null;
}

export interface ProjectFilter {
  status?: ProjectStatus;
  includeDeleted?: boolean;
  /** Match projects that have a milestone with this name in their catalog (issue #646) */
  milestoneName?: string;
  /** Match projects that have an outcome with this name in their catalog (issue #646) */
  outcomeName?: string;
}

export interface ProjectMilestone {
  entityId: string;
  entityType: string;
  projectId: string;
  name: string;
  sequence: number;
  targetDate?: string | null;
  status: ProjectMilestoneStatus;
  description?: string | null;
  _schemaVersion: string;
  _createdAt: string;
  _createdBy: string;
  _updatedAt: string;
  _updatedBy: string;
  _deletedAt?: string | null;
}

export interface ProjectOutcome {
  entityId: string;
  entityType: string;
  projectId: string;
  name: string;
  description?: string | null;
  displayOrder: number;
  status: ProjectOutcomeStatus;
  _schemaVersion: string;
  _createdAt: string;
  _createdBy: string;
  _updatedAt: string;
  _updatedBy: string;
  _deletedAt?: string | null;
}

// ─── Business Pillar CRUD entities (issue #400) ──────────────────────────────

export interface ServiceAssignment {
  serviceId: string;
  milestoneId: string;
  projectId: string;
  outcomeId: string;
  assignmentStatus: AssignmentStatus;
  assignedBy: string;
  assignedAt: string;
  statusNote?: string | null;
  _createdAt: string;
  _updatedAt: string;
}
